import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.RemplazoUsuario;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un RemplazoUsuario
*/
export class RemplazoUsuarioEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        const reglas: validation.Rules<Entity> = {
            NombreUsuario: validation.required
        }

        const password: validation.Rules<Entity> = {
            Password: validation.required,
            ConfirmarPassword: x => x.Password == x.ConfirmarPassword
        };

        return validation.andRules(reglas, validation.when(true, password));
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Password = getField(kea.Password);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={validation.hasError(this.errors())} />]}
                onClose={this.onCerrar}
                title="Información nuevo usuario"
            >

                {kea.autogrid(3, [
                    <Text field="NombreUsuario" label="Nombre de usuario:" />,
                    <Password field="Password" label="Contraseña:" />,
                    <Password field="ConfirmarPassword" label="Confirmar contraseña:" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarios/list/remplazarusuariomodal.tsx